// Configuración de colores por estado de actividad (incumplimientos)
export const statusColorConfig = {
    'Pendiente': '#f08c00',   
    'En revisión': '#228be6',  
    'Aprobado': '#2f9e44',    
    'Rechazado': '#fa5252',    
    'Expirado': '#868e96',     
};

// Configuración de estados para TaskAccordion
export const statusConfig = {
    'Pendiente':   { label: 'Pendiente',   iconClass: 'icon-clock',       color: 'yellow', bgColor: '#fff9db' },
    'En revisión': { label: 'En revisión', iconClass: 'icon-eye',         color: 'blue',   bgColor: '#e7f5ff' },
    'Aprobado':    { label: 'Aprobado',    iconClass: 'icon-thumbs-up',   color: 'green',  bgColor: '#ebfbee' },
    'Rechazado':   { label: 'Rechazado',   iconClass: 'icon-thumbs-down', color: 'red',    bgColor: '#fff5f5' },
    'Expirado':    { label: 'Expirado',    iconClass: 'icon-ban',         color: 'gray',   bgColor: '#f1f3f5' },
};